import React from "react";

interface UploadButtonProps {
    isLoading: boolean;
    disabled: boolean;
    onClick: () => void;
}

const UploadButton: React.FC<UploadButtonProps> = ({ isLoading, disabled, onClick }) => {
    return (
        <div className={"mt-6"}>
            <button
                onClick={onClick}
                disabled={disabled || isLoading}
                className="primary px-6 py-3 w-auto"
            >
                {isLoading ? "Processing..." : "Upload Data"}
            </button>
        </div>
    );
};

export default UploadButton;
